import { render, staticRenderFns } from "./Photo_Album.vue?vue&type=template&id=5a119c44&scoped=true"
import script from "./Photo_Album.vue?vue&type=script&lang=js"
export * from "./Photo_Album.vue?vue&type=script&lang=js"
import style0 from "./Photo_Album.vue?vue&type=style&index=0&id=5a119c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a119c44",
  null
  
)

export default component.exports